import React, { Fragment, useEffect, useRef } from 'react';
import styled from 'styled-components';

// Components

import ModalHeader from '../headers/ModalHeader';

// Utils

import { preventerTools } from '@utils/tools/preventerTools';

//hooks

import { useTrapFocus } from '@hooks/useTrapFocus';

const ResponsiveIframe = styled.iframe`
    width: 100%;
    height: 100%;
    min-height: 0;
    max-height: none;
    border: none;
    box-sizing: border-box;
    display: block;
    
    /* Responsive adjustments for high zoom levels */
    @media (max-width: 768px) {
        height: 60vh;
        min-height: 400px;
    }
    
    @media (max-width: 480px) {
        height: 50vh;
        min-height: 300px;
    }
    
    /* Support for high DPI/zoom scenarios */
    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
        height: 65vh;
    }
    
    /* Additional zoom support */
    @media screen and (max-width: 1200px) and (min-width: 769px) {
        height: 65vh;
        min-height: 450px;
    }
`;

const ModalContainer = styled.div`
    .gi-modal__body.locate-assistance-modal {
        padding: 0;
        overflow: auto;
        width: 100%;
        max-width: 100%;
        max-height: none;
        margin-bottom: 0;
        box-sizing: border-box;
        
        /* Ensure modal scales properly with zoom */
        @media (max-width: 768px) {
            padding: 10px;
        }
    }
`;

const LocateAssistanceModal = props => {

    const {
        actions: {
            hideModal
        },
        modal: {
            modalData
        },
        modalHeaderProps
    } = props;
    
    const {
        customEvent,
        skipReloadOnDesignation
    } = preventerTools.provideObject(modalData);

    const iframeRef = useRef(null);
    const modalRef = useRef(null);

    const { handleIframeLoad } = useTrapFocus({
        modalRef,
        iframeRef,
        customEvent,
        onClose: () => {
            if (!refreshPageIfDesignationSuccess()) {
                hideModal();
            }
        }
    });

    useEffect(() => {
        if(customEvent) {
            const closeModalFromIframe = e => {
                if(e.detail.event === customEvent) {
                    if (!refreshPageIfDesignationSuccess()) {
                        hideModal();
                    }
                }
            };
            window.customEvent = customEvent;
            window.addEventListener(customEvent, closeModalFromIframe);
            return () => {
                delete window.customEvent;
                window.removeEventListener(customEvent, closeModalFromIframe);
            };
        }
    }, [ ]);

    const refreshPageIfDesignationSuccess = () => {
        clearAssisterSessionStorage();

        if (window.designationCompleted) {
            window.designationCompleted = false;
            if (!skipReloadOnDesignation) {
                window.onbeforeunload = null;
                window.location.reload();
                return true;
            }
        }
        return false;
    };

    function clearAssisterSessionStorage() {
        const keysToRemove = [
            'isDataLoaded',
            'dataLoadedForm',
            'backFromAssister',
            'formName',
            'pageNumber',
            'businessName',
            'locationSessionData',
        ];

        keysToRemove.forEach((key) => sessionStorage.removeItem(key)); 
    }   

    return (
        <Fragment>
            <ModalContainer ref={modalRef}>
                <ModalHeader { ...{ ...modalHeaderProps, hideModalCallback: () => {refreshPageIfDesignationSuccess();} } }/>
                <div className="gi-modal__body locate-assistance-modal" id = 'locateAssistanceModal'>
                    <ResponsiveIframe 
                        id="brokersearchBox" 
                        ref={iframeRef} 
                        src="/hix/broker/search" 
                        title="Find Local Assistance" 
                        className="searchModal-body" 
                        onLoad={handleIframeLoad}
                    />
                </div>
            </ModalContainer>
        </Fragment>
    );
};

export default LocateAssistanceModal;
